import axios from "axios";
export default ()=>{
    const wrapper = document.querySelector('[data-main-grid-wrapper]');
    wrapper?makeGrid():false;

    function makeGrid(){
        const title = document.querySelector('[data-main-grid-title]');
        const list = document.querySelector('[data-main-grid-products]');
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        let type,sex, products;

        // #region SET PAGE TITLE
        
            for (const [key, value] of Object.entries(params)) {
                type = value;
                sex = key;
            }
            if ( type!='false') {
                title.innerHTML = `${sex}&nbsp;<span class="dash">—</span>&nbsp;<span>${type}</span>`
                if (sex == 'gifts') {
                    title.innerHTML = `${sex}`;
                }
            } else {
                title.innerHTML = `${sex}`;
            }
        //#endregion

        axios.get('/?view=json')
			.then((response) => {
                products  = response.data.products;
			}).then(() =>{
                buildList(products, sex, type)
                
            }).then(()=>{
                window.fade();
            })

        // #region BUILD LIST
            function buildList(products, sex, type){
                products.forEach(el =>{
                    if (sex == 'gifts' && el.title.toUpperCase().includes('CARD')) {
                        singleItem(el)
                    } else {
                        if (type == 'false' && el.sex == sex){
                            singleItem(el)
                        } else if(el.sex == sex && el.type == type) {
                            singleItem(el)
                        }
                    }
                    
                })
            }
        //#endregion
        
        // #region BUILD SINGLE ITEM
            function singleItem(product){
                
                let media = product.media;
                let media2 = product.media2;
                let  twoimgs, img2, price, title, vendor, color, colorRaw, active
                let colorInner = '';
                //#region PRICE AND MEDIA
                    media2.length>0?twoimgs = ' two-imgs': twoimgs = '';
                    media2.length>0?img2 = `<img src="${media2 }" alt="">`: img2 = '';
                    product.title.toUpperCase().includes('CARD')?price='':price = ` <p>${product.price}</p>`;
                //#endregion
                
                //#region TITLE and Vendor
                    if ( product.newTitle.length>0) {
                        if ( product.color.length>0) {
                            title =  `<p><a href='${product.url}'>${ product.newTitle} in ${product.color}</a></p>`
                        } else {
                            title =  `<p><a href='${product.url}'>${ product.newTitle}</a></p>`
                        }
                    } else {
                        title =  `<p><a href='${product.url}'>${product.title}</a></p>`
                    }

                    product.vendor.length>0?vendor=product.vendor:vendor=product.collection;
                //#endregion
                
                //#region product colors
                    const titlesArray = product.shoptitles.slice(0, -1).split(';');
                    const hexArray = product.shophex.slice(0, -1).split(';');
                    
                    products.forEach(pr =>{
                        if (pr.tag == product.tag){
                            titlesArray.forEach((title, index) =>{
                                let a = title.replace(' ', '_').toUpperCase();
                                if (a == pr.color.replace(' ', '_').toUpperCase()){
                                    pr.color == product.color? active = 'active': active = ''
                                    colorRaw = `
                                    <a href="${pr.url}" title="${pr.title}" class="color-input ${active}">
                                        <span  style="color:${hexArray[index]}"></span>
                                    </a>`
                                }
                            })
                            colorInner = colorInner + colorRaw
                        }
                    })
                    
                    product.title.toUpperCase().includes('CARD')?color='':color = ` <div class="product-actions_colors" data-color-wrapper>   
                    ${colorInner}</div>`;
                //#endregion
                
                //#region Element layout
                    let div = document.createElement('div');
                    
                    div.className = "search-result";
                    div.setAttribute('data-animation-fadey', '');
                    div.innerHTML = `
                    <a href='${product.url}' class="search-result__img-wrap  ${twoimgs}">
                        <img src="${media}" alt="">
                        ${img2}
                    </a>
                    <div class="search-result__colors">
                        <p>${vendor}</p>
                        ${color}
                    
                    </div>
                    
                    ${title}
                    ${price}`
                    list.append(div)
                //#endregion
            }   
        //#endregion         		
    }
}